import { useStaticQuery, graphql } from "gatsby";

export const useMediaFileFile = () => {
  const { allMediaImage } = useStaticQuery(graphql`
    query allMediaImage {
      allMediaImage {
        edges {
          node {
            drupal_id
            field_media_image {
              alt
              title
            }
            relationships {
              field_media_image {
                publicUrl
                drupal_id
              }
            }
          }
        }
      }
    }
  `);

  return allMediaImage.edges;
};